import { update } from './update';

export function request({ old, email }) {
    return {
        type: 'USER_CHANGE_EMAIL_REQUEST',
        old,
        email
    };
}

export function error(errors) {
    return {
        type: 'USER_CHANGE_EMAIL_ERROR',
        errors
    };
}

export function finish(user) {
    return (dispatch) => {
        dispatch(update(user));

        dispatch({
            type: 'USER_CHANGE_EMAIL_FINISH'
        });
    };
}

export function clear() {
    return {
        type: 'USER_CHANGE_EMAIL_CLEAR'
    };
}
